import React, { useState } from "react";
import Contact from "../Contact/Contact";
import Footer from "../Footer/Footer";
import Landing from "../Landing/Landing";
import Navbar from "../NavBar/Navbar";
import NavbarMenu from "../NavbarMenu/NavbarMenu";
import SideBar from "../SideBar/SideBar";
import faculty_1 from "../../image/newImg/1.png";
import faculty_2 from "../../image/newImg/2.png";
import faculty_3 from "../../image/newImg/3.png";
import faculty_4 from "../../image/newImg/4.png";
import faculty_5 from "../../image/newImg/5.png";
import faculty_6 from "../../image/newImg/6.png";
import fsTopIcon from "../../image/newImg/fs.png";

import faculty from "../../image/newImg/stafflistpng.png";
import "./Content.css";
import ContentMain from "./ContentMain";
import { Helmet } from "react-helmet";
import NewNavbar from "../NavBar/NewNavbar";
function Faculty(props) {
  const {
    cover,
    sidebar_data,
    data,
    title,
    alumni_data,
    curriculum_data,
    side_heading,
    side_sub_heading,
  } = props;
  // const canonicalUrl = `https://hermanngmeinerschoolfaridabad.org/faculty-staff`;
  const [isScrolled, setIsScrolled] = useState(false);
  const [isShow, steIsShow] = useState(false);
  const handleScroll = (e) => {
    console.log("asd");
    if (e.target.scrollTop > 0 && !isScrolled) {
      setIsScrolled(true);
    }
    if (e.target.scrollTop === 0) {
      setIsScrolled(false);
    }
  };
  const handleClick = () => {
    steIsShow(!isShow);
    console.log(isShow);
  };
  return (
    <div className="content_main" onScroll={handleScroll}>
      <Helmet>
        <title>Meet Our Dedicated Faculty at HGS Faridabad</title>
        <meta name='description' content='Discover the experienced and qualified faculty at HGS Faridabad. Learn about our dedicated teachers committed to nurturing student success.' />
        <meta name='Keywords' content='HGS faculty, teaching staff Faridabad, experienced teachers Faridabad, school staff profiles, qualified teachers Faridabad' />
        <link rel='canonical' href='https://hermanngmeinerschoolfaridabad.org/faculty-staff' />
      </Helmet>
      <NewNavbar handleClick={handleClick} />
      {/* <Navbar isScrolled={isScrolled} handleClick={handleClick} /> */}
      <NavbarMenu isShow={isShow} handleClick={handleClick} />
      <Landing video={false} cover={cover} />
      <div className="contentmain_cont">
        <div style={{ width: "min-content" }}>
          <SideBar
            sidebar_data={sidebar_data}
            side_heading={side_heading}
            side_sub_heading={side_sub_heading}
          />
          <Contact />
        </div>
        <div>
          <div className={`f-2 f-500 mb-3`} style={{ color: "#0076BD" }}>
            <img
              src={fsTopIcon}
              style={{ width: "4rem", marginRight: "1rem" }}
            />

            <h1 style={{ display: "inline-block" }}>Faculty & Staff</h1>
          </div>
          <div>
            <div className="d-flex gap-2 mt-1">
              <div>
                {/* <div className="f-bold f-1-2 mb-2"></div> */}
                <div className="color-grey f-500">
                  HGS Faridabad has a very experienced,
                  knowledgeable, well-qualified and dedicated Staff, so much so
                  that they are conscious of their responsibility of being the
                  most important block in the foundation of the Nation as well
                  as the Society.
                </div>
                <div className="color-grey f-500 mt-2">
                  Their self-discipline is an example in itself, which always
                  drives them to work as a well-knit team to make all possible
                  endeavour together for the holistic growth of students as well
                  the institution. They are enthusiastic, dedicated,
                  conscientious and highly motivated to adapt to new innovative
                  ideas and well versed with modern education systems.
                </div>
                <div className="color-grey f-500 mt-2">
                  The valuable contribution of all the Faculty members is well
                  manifested in the spectacular achievements of our students in
                  the scholastic as well as co- scholastic discipline.
                </div>
                <div className="color-grey f-500 mt-2">
                  The Teachers grouped under various subject-wise Faculties are
                  put under the guidance of the most experienced Faculty heads.
                  All of them always put their heads together to devise
                  improvised methodology to deliver their best to facilitate the
                  young evolving minds. This significantly contributes in
                  promoting the problem solving skills of students to enable
                  them to grow as useful citizens.
                </div>
              </div>
            </div>
          </div>

          <div className="faculty_staff mt-4">
            <table className="table table-bordered table-striped table-hover">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Name</th>
                  <th>Qualification</th>
                  <th>Designation</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>1</td><td>DEBOLEENA CHOWDHURI</td><td>MA, B.ED</td><td>PRINCIPAL</td></tr>
                <tr><td>2</td><td>RENUKA BHAT</td><td>MA, M.ED</td><td>HEAD MISTRESS</td></tr>
                <tr><td>3</td><td>SUNIL SINGH TEWATIA</td><td>MA, B.ED</td><td>PGT (Hindi)</td></tr>
                <tr><td>4</td><td>JYOTI KAUSHIK</td><td>MA, M.PHIL, B.ED</td><td>PGT (Political Sc)</td></tr>
                <tr><td>5</td><td>RAM KUMAR</td><td>M.SC, B.ED</td><td>PGT (Maths)</td></tr>
                <tr><td>6</td><td>JITENDRA KUMAR</td><td>M.SC, B.ED</td><td>PGT (Chemistry)</td></tr>
                <tr><td>7</td><td>NARESH KUMAR</td><td>M.PED</td><td>PGT (P.Ed)</td></tr>
                <tr><td>8</td><td>ASHISH KUMAR MISHRA</td><td>M.SC, B.ED</td><td>PGT (Physics)</td></tr>
                <tr><td>9</td><td>ANURADHA</td><td>M.SC, B.ED</td><td>PGT (Biology)</td></tr>
                <tr><td>10</td><td>MAHINDER</td><td>MCA</td><td>PGT (C.Sc &amp; A.I)</td></tr>
                <tr><td>11</td><td>GEETANSHI</td><td>MA PSYCHOLOGY &amp; PG DIPLOMA in GUIDANCE &amp; COUNSELLING</td><td>PGT (Psychology) Cum Counsellor</td></tr>
                <tr><td>12</td><td>AMITA BANSAL</td><td>M.COM, MBA, B.ED</td><td>PGT (Accountancy &amp; Marketing)</td></tr>
                <tr><td>13</td><td>HARVEEN KAUR KAPOOR</td><td>MA(ECO), B.ED</td><td>PGT (Economics)</td></tr>
                <tr><td>14</td><td>ANUKRITI</td><td>M.COM, MA(ECO), B.ED</td><td>PGT (B.St Cum Counsellor)</td></tr>
                <tr><td>15</td><td>ANJALI NEGI</td><td>MA, B.ED, TEFL, DCE</td><td>PGT (English &amp; Mass Media)</td></tr>
                <tr><td>16</td><td>DIVYA SINGHAL</td><td>M.COM, B.ED</td><td>PGT(Economics)</td></tr>
                <tr><td>17</td><td>VARUN BAGGI</td><td>MFA</td><td>PGT (Painting)</td></tr>
                <tr><td>18</td><td>MANGE RAM</td><td>MA(YOGA), B.PED, BEMS</td><td>PGT(P.Ed)</td></tr>
                <tr><td>19</td><td>SANDEEP KUMAR SHARMA</td><td>MA, B.ED</td><td>PGT(English)</td></tr>
                <tr><td>20</td><td>ANURAG ADHANA</td><td>MA, B.PED</td><td>PGT (Yoga)</td></tr>
                <tr><td>21</td><td>DEEPIKA KACHROO</td><td>B.SC, HDSM, M.ED</td><td>TGT (Science)</td></tr>
                <tr><td>22</td><td>ANURADHA RAI SHUKLA</td><td>M.SC, B.ED</td><td>TGT (Science)</td></tr>
                <tr><td>23</td><td>ANANT SHANKAR SHRIVASTAVA</td><td>M.SC, B.ED</td><td>TGT (Maths)</td></tr>
                <tr><td>24</td><td>KAMLESH KUMARI NARWAT</td><td>MA,M.ED</td><td>TGT (Hindi)</td></tr>
                <tr><td>25</td><td>SHWETA BHATI</td><td>MA, B.ED</td><td>TGT(Hindi)</td></tr>
                <tr><td>26</td><td>BABITA</td><td>M.SC, B.ED</td><td>TGT (Maths)</td></tr>
                <tr><td>27</td><td>JYOTI</td><td>MCA</td><td>TGT (Computer and IT)</td></tr>
                <tr><td>28</td><td>SONIYA SINGH</td><td>BA, B.ED</td><td>TGT(Hindi)</td></tr>
                <tr><td>29</td><td>MR. RAJDEV KUMAR</td><td>MA, MSW, D.ED, B.ED</td><td>TGT(Social Science Cum Counsellor))</td></tr>
                <tr><td>30</td><td>MANISHA CHAUHAN</td><td>M.SC, B.ED</td><td>TGT (Science)</td></tr>
                <tr><td>31</td><td>SOMYA ARORA</td><td>MA(ENG), MBA, B.ED</td><td>TGT (English)</td></tr>
                <tr><td>32</td><td>VANSHIKA DANG</td><td>MA, B.ED</td><td>TGT(English)</td></tr>
                <tr><td>33</td><td>LAXMI BHARDWAJ</td><td>B.COM, B.ED</td><td>TGT(Social Science)</td></tr>
                <tr><td>34</td><td>RUBY RANI JENA</td><td>MA, B.ED</td><td>TGT(Social Science)</td></tr>
                <tr><td>35</td><td>HARENDER YADAV</td><td>BFA</td><td>TGT(Art)</td></tr>
                <tr><td>36</td><td>KAPIL YADAV</td><td>MSC, B.ED</td><td>TGT(Maths)</td></tr>
                <tr><td>37</td><td>SUSHA SOPORY</td><td>MA, B.ED</td><td>TGT(Sanskrit)</td></tr>
                <tr><td>38</td><td>SHELLY MOHINDRA</td><td>B.COM, B.ED</td><td>TGT(Social Science)</td></tr>
                <tr><td>39</td><td>SAPNA CHAKRABORTY</td><td>MA, B.ED, VISHARD</td><td>TGT(Music)</td></tr>
                <tr><td>40</td><td>PRIYA MAGARDE</td><td>MSC, B.ED, SANGEET KALA PRAVESHIKA</td><td>TGT(Dance)</td></tr>
                <tr><td>41</td><td>NITIKA GUPTA</td><td>M.SC, B.ED</td><td>TGT(Science)</td></tr>
                <tr><td>42</td><td>RADHA RANA</td><td>B.COM, DIPLOMA(ASD)</td><td>SPECIAL EDUCATOR</td></tr>
                <tr><td>43</td><td>JUHI BRAHMACHARY</td><td>MA</td><td>TGT (English)</td></tr>
                <tr><td>44</td><td>RAKHI</td><td>BA, B.LIB</td><td>LIBRARIAN</td></tr>
                <tr><td>45</td><td>RITIKA</td><td>BSC(CHEM HONORS), ROBOTICS TRAINING</td><td>TGT(Robotics)</td></tr>
                <tr><td>46</td><td>ANKIT ROUTELA</td><td>M.PED</td><td>TGT(P.Ed)</td></tr>
                <tr><td>47</td><td>NEETU DIXIT</td><td>B.COM, ADVANCE DIPLOMA FRENCH</td><td>TGT(French)</td></tr>
                <tr><td>48</td><td>RUBBAL MONGA</td><td>MA(Sociology, Political Sc), NTT, B.Ed, B.LIB, M.LIB</td><td>PRT</td></tr>
                <tr><td>49</td><td>ANJALI MADAN</td><td>M.COM, B.ED</td><td>PRT</td></tr>
                <tr><td>50</td><td>DEEPIKA KAUSHIK</td><td>B.COM, B.ED, D.ED</td><td>PRT</td></tr>
                <tr><td>51</td><td>SUKHBIR KAUR VIRDI</td><td>MA, B.SC, B.ED</td><td>PRT</td></tr>
                <tr><td>52</td><td>HEENA</td><td>DOUBLE MA, NTT, B.ED</td><td>PRT</td></tr>
                <tr><td>53</td><td>JYOTI SINGH</td><td>B.COM, B.ED</td><td>PRT</td></tr>
                <tr><td>54</td><td>PRIYANKA KATHURIA</td><td>M.COM, B.ED</td><td>PRT</td></tr>
                <tr><td>55</td><td>DEEPMALA</td><td>M.COM, MBA, B.ED</td><td>PRT</td></tr>
                <tr><td>56</td><td>KAVITA AGGARWAL</td><td>MA(SC OF LIVING PREKSHA MEDITATION AND YOGA), B.ED, MA(HINDI)</td><td>Wellness Teacher</td></tr>
                <tr><td>57</td><td>PRIYA KARNATAKA</td><td>M.SC(CHEM), B.ED</td><td>PRT</td></tr>
                <tr><td>58</td><td>GYAN MANJARI</td><td>MA, B.ED, NTT</td><td>PRT</td></tr>
                <tr><td>59</td><td>ANKITA BHANDARI</td><td>B.COM, B.ED</td><td>PRT</td></tr>
                <tr><td>60</td><td>RITIKA DHAWAN</td><td>M.COM, B.ED</td><td>PRT</td></tr>
                <tr><td>61</td><td>HEENU SHARMA</td><td>B.SC, B.ED</td><td>PRT</td></tr>
                <tr><td>62</td><td>ASHWANI</td><td>BA, B.PED</td><td>PRT</td></tr>
                <tr><td>63</td><td>HARSHITA CHAURASIA</td><td>BSC, B.ED</td><td>PRT</td></tr>
              </tbody>
            </table>
          </div>


        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Faculty;
